import React, { useEffect } from 'react';
import { StepHelpedDonateProps } from '../types';

// PayPal SDK type declarations
declare global {
  interface Window {
    paypal?: {
      HostedButtons: (config: { hostedButtonId: string }) => {
        render: (selector: string) => void;
      };
    };
  }
}

const StepHelpedDonate: React.FC<StepHelpedDonateProps> = ({ state, onUpdate }) => {
  const handleAnswer = (answer: 'yes' | 'no') => {
    onUpdate({ helpedAnswer: answer });
  };

  useEffect(() => {
    const initializePayPalButton = () => {
      if (window.paypal && typeof window.paypal.HostedButtons === 'function') {
        window.paypal.HostedButtons({
          hostedButtonId: "XTPAS9P7DQRHU"
        }).render("#paypal-container-XTPAS9P7DQRHU");
      }
    };

    // Wait for PayPal SDK to be ready, then initialize button
    if (window.paypal && typeof window.paypal.HostedButtons === 'function') {
      // PayPal SDK is already loaded
      initializePayPalButton();
    } else {
      // Wait for PayPal SDK to load
      const checkPayPal = () => {
        if (window.paypal && typeof window.paypal.HostedButtons === 'function') {
          initializePayPalButton();
        } else {
          // Check again in a short timeout
          setTimeout(checkPayPal, 100);
        }
      };
      checkPayPal();
    }
  }, []);

  const getResponseMessage = () => {
    if (state.helpedAnswer === 'yes') {
      return (
        <div style={{ textAlign: 'center', marginBottom: '32px', padding: '24px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
          <p style={{ fontSize: '18px', color: '#28a745' }}>
            That's great news. Trust that feeling and good luck — you've got this.
          </p>
        </div>
      );
    }

    if (state.helpedAnswer === 'no') {
      return (
        <div style={{ textAlign: 'center', marginBottom: '32px', padding: '24px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
          <p style={{ fontSize: '18px', color: '#6c757d' }}>
            Sorry we couldn't help this time — and that's okay. Sometimes not choosing is also information. Good luck.
          </p>
        </div>
      );
    }

    return null;
  };

  return (
    <>
      <div className="feedback-section">
        <h2 className="step-title">Did this help you make a decision?</h2>

        {!state.helpedAnswer && (
          <div className="feedback-buttons">
            <button
              className="btn"
              onClick={() => handleAnswer('yes')}
            >
              Yes
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => handleAnswer('no')}
            >
              No
            </button>
          </div>
        )}

        {getResponseMessage()}
      </div>

      <div className="donate-section">
        <p style={{ marginBottom: '16px' }}>
          If you'd like to support this project:
        </p>
        {/* PayPal Donate Button */}
        <div id="paypal-container-XTPAS9P7DQRHU"></div>
      </div>
    </>
  );
};

export default StepHelpedDonate;
